export { ThankyouDetail } from './ThankyouDetail';
